var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module dt-top-simple" }, [
    _c("div", { staticClass: "dt-top-simple-sec" }, [
      _c("header", { staticClass: "dt-header-simple" }, [
        _c("a", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.backStatus,
              expression: "backStatus",
            },
          ],
          staticClass: "back",
          attrs: { uigs: "head_back", href: "javascript:void(0);" },
          on: { click: _vm.backPrev },
        }),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.headTitle))]),
        _vm._v(" "),
        _c("a", {
          staticClass: "home",
          attrs: {
            href: "/?source=node&spver=" + _vm.spver,
            uigs: "head_home",
          },
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "search",
          attrs: { href: "/hotsugg?spver=" + _vm.spver, uigs: "head_search" },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dt-info-img-simple" },
        [_c("Image-1", { attrs: { src: _vm.item.v_picurl } })],
        1
      ),
      _vm._v(" "),
      _c("figure", { staticClass: "dt-info-box-simple" }, [
        _vm.item.name
          ? _c("figcaption", [
              _vm._v("\n        " + _vm._s(_vm.item.name) + "\n      "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.tag && _vm.tag.length > 0
          ? _c(
              "p",
              { staticClass: "dt-info-tag-simple" },
              [
                _vm._l(_vm.tag, function (v, index) {
                  return [
                    _c(
                      "a",
                      { key: index, attrs: { href: "javascript:void(0);" } },
                      [_vm._v(_vm._s(v))]
                    ),
                    _vm._v(" "),
                    index !== _vm.tag.length - 1
                      ? _c("em", { key: index }, [_vm._v("/")])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.item.starring && typeof _vm.item.starring !== undefined
          ? _c(
              "p",
              { staticClass: "dt-info-tag-simple" },
              [
                _c("span", [_vm._v("主演：")]),
                _vm._v(" "),
                _vm._l(_vm.item.starring.split(";"), function (str, index) {
                  return [
                    index !== 0
                      ? _c("em", { key: index }, [_vm._v(" ")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        key: index,
                        attrs: {
                          href: "javascript:void(0);",
                          uigs: "basic_out",
                        },
                      },
                      [_vm._v(_vm._s(str))]
                    ),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }